var StateDefaults = {
    initialized: false,
    loading: false,
    loadingTooLong: false,
    loadQueued: false,
    loadCount: 0,
    loader: null,
    loadFailure: false,
    updating: false,
    updateFailure: false,
};
var StateModifiers = {
    startLoading: function (state) {
        state.loading = true;
        state.loadFailure = false;
        state.loadCount = state.loadCount + 1;
    },
    setLoadingTooLongIfLoading: function (state) {
        state.loadingTooLong = state.loading;
    },
    stopLoading: function (state, success) {
        state.loadCount = state.loadCount - 1;
        if (state.loadCount == 0) {
            state.loadFailure = !success;
            state.initialized = state.initialized || success;
            state.loading = false;
            state.loadingTooLong = false;
        }
    },
    startUpdating: function (state) {
        state.updating = true;
        state.updateFailure = false;
    },
    stopUpdating: function (state, success) {
        state.updateFailure = !success;
        state.updating = false;
    },
};
export { StateDefaults as LoadingStateDefaults, StateModifiers as LoadingStateModifiers, };
